var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTimesActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.50585 2.01416C7.95385 2.01416 7.50585 2.46216 7.50585 3.01416C5.29686 3.01416 3.50586 4.80516 3.50586 7.01416V8.07617L21.5058 8.01416V7.01416C21.5058 4.80516 19.7148 3.01416 17.5058 3.01416C17.5058 2.46216 17.0578 2.01416 16.5058 2.01416C15.9538 2.01416 15.5058 2.46216 15.5058 3.01416H9.50585C9.50585 2.46216 9.05785 2.01416 8.50585 2.01416ZM3.50586 10.0142V17.0142C3.50586 19.2232 5.29686 21.0142 7.50585 21.0142H17.5058C19.7148 21.0142 21.5058 19.2232 21.5058 17.0142V10.0142H3.50586Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimesActive);
export default __webpack_public_path__ + "static/media/TimesActive.2ff0466cf3c13d97ace5928aa26109c9.svg";
export { ForwardRef as ReactComponent };